var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import FileUpload from '~/components/common/file-upload.vue';
var CollectionExecutionModule = namespace("collection-execution");
var AddCaseRemark = /** @class */ (function (_super) {
    __extends(AddCaseRemark, _super);
    function AddCaseRemark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rules = {
            content: [{ required: true, message: '请输入备注内容' }],
        };
        _this.submitLoading = false;
        _this.applyModel = {
            content: '',
        };
        return _this;
    }
    AddCaseRemark.prototype.close = function () {
        var form = this.$refs['form'];
        form.resetFields();
    };
    AddCaseRemark.prototype.commit = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.validate(function (result) {
            if (!result)
                return;
            _this.submitLoading = true;
            _this.caseOperatorPageService.addCaseRemark({
                caseId: _this.caseId,
                content: _this.applyModel.content
            }).subscribe(function (data) {
                _this.submitLoading = false;
                _this.$message.success('添加备注成功');
                _this.close();
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], AddCaseRemark.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddCaseRemark.prototype, "caseId", void 0);
    __decorate([
        Emit('close')
    ], AddCaseRemark.prototype, "close", null);
    AddCaseRemark = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
            }
        })
    ], AddCaseRemark);
    return AddCaseRemark;
}(Vue));
export default AddCaseRemark;
